/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useContext} from "react";
import {Col, Form, Row, Switch} from "antd";
import MapPropsContext from "../MapPropsContext";
import {Title} from "./Common";


export default function WidgetHeatmapSwitch() {
  const {
    isHeapmapByPoint,
    setIsHeapmapByPoint,
  } = useContext(MapPropsContext);

  const onChange = useCallback(() => {
    setIsHeapmapByPoint(checked => !checked);
  }, []);

  return (
    <Form.Item>
      <Title>검색 옵션</Title>
      <Row>
        <Col span={6}>
          히트맵
        </Col>
        <Col span={18}>
          <Switch onChange={onChange} checked={isHeapmapByPoint} />
        </Col>
      </Row>
    </Form.Item>
  );
}
